import React from 'react';
import { IconRefresh } from '@tabler/icons-react';
import { t } from 'i18next';
import { notifications } from '@mantine/notifications';
import { theme } from '../style/theme';

// Get the NotificationPosition type from notifications.show's parameters
type NotificationPosition = Parameters<typeof notifications.show>[0]['position'];
type CSSPosition = 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';

export const getVersionMismatchMessage = (): React.ReactNode => (
  <span>
    {t('notifications.versionMismatchMessage')}
    {' '}
    <a 
      href="#" 
      onClick={(e) => {
        e.preventDefault();
        window.location.reload();
      }}
      style={{ 
        color: '#3498DB', 
        textDecoration: 'underline',
        fontWeight: 'bold',
        cursor: 'pointer'
      }}
    >
      {t('notifications.reload')}
    </a>
  </span>
);

export const getVersionMismatchIcon = (): React.ReactNode => (
  <div 
    style={{ cursor: 'pointer' }} 
    onClick={() => window.location.reload()}
    title={t('notifications.reload', 'Reload Now')}
  >
    <IconRefresh style={{ width: 20, height: 20, marginTop: '7px' }} /> 
  </div>
);

export const versionMismatchStyles = { 
  root: { 
    zIndex: 9999,
    backgroundColor: '#2C3E50',
    borderColor: '#9998DB',
    color: 'white',
    boxShadow: theme.shadows?.md,
    borderRadius: theme.radius?.lg,
    position: 'fixed' as CSSPosition,
    bottom: '20px',
    right: '20px',
    maxWidth: '400px',
    width: 'auto',
    minHeight: '100px',
    height: 'auto',
    overflow: 'hidden',
    transition: 'all 300ms ease'
  },
  title: { color: 'white', fontWeight: 600 },
  description: { color: '#E0E0E0' },
};

export const getVersionMismatchNotificationConfig = (onClose: () => void) => ({
  id: 'version-mismatch',
  title: t('notifications.versionMismatchTitle'),
  message: getVersionMismatchMessage(),
  color: 'indigo.7',
  withCloseButton: false,
  autoClose: false,
  withBorder: true,
  icon: getVersionMismatchIcon(),
  styles: versionMismatchStyles,
  position: 'bottom-right' as NotificationPosition,
  onClose
}); 